const EVENT_NAME = "fonts:ready";
const CLASS_NAME = "fonts-loaded";

export function initFontsGate(fontFamily = "Manrope", weights = [400, 700]) {
  if (window.__WV_FONTS_GATE_INITED__) return;
  window.__WV_FONTS_GATE_INITED__ = true;

  const markLoaded = () => {
    document.documentElement.classList.add(CLASS_NAME);
    window.dispatchEvent(new Event(EVENT_NAME));
  };

  if (document.fonts?.load) {
    Promise.all(weights.map((w) => document.fonts.load(`${w} 1em "${fontFamily}"`)))
      .then(markLoaded)
      .catch(markLoaded);
  } else {
    markLoaded();
  }
}
